// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"6f3a1a47","438":"f3151c80","461":"c18b5338","534":"82b756da"}[chunkId] + ".chunk.js";
};